import { motion } from "framer-motion";
import { Gift, Heart, Phone, Mail } from "lucide-react";

const IMAGE_URL =
    "https://customer-assets.emergentagent.com/job_cindy-naissance/artifacts/u463pmah_622966363_18557565406003039_5773611137074574290_n.jpg";

export default function BonCadeau() {
    return (
        <section
            id="bon-cadeau"
            data-testid="bon-cadeau-section"
            className="py-24 md:py-36 bg-rose-50/60"
        >
            <div className="max-w-6xl mx-auto px-6 md:px-12">
                <div className="grid md:grid-cols-12 gap-12 md:gap-16 items-center">
                    {/* Image */}
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.9 }}
                        className="md:col-span-5"
                    >
                        <div className="relative rounded-[2rem] overflow-hidden border border-rose-100 shadow-sm bg-cream">
                            <img
                                src={IMAGE_URL}
                                alt="Bon cadeau Cindy Bien-Naître"
                                className="w-full h-auto object-contain"
                                data-testid="bon-cadeau-image"
                            />
                        </div>
                    </motion.div>

                    {/* Text */}
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.9, delay: 0.1 }}
                        className="md:col-span-7"
                    >
                        <span className="inline-flex items-center gap-2 text-xs tracking-[0.25em] uppercase text-rose-700">
                            <Gift size={14} />
                            Bon cadeau
                        </span>
                        <h2
                            className="font-serif text-4xl md:text-5xl lg:text-6xl text-ink mt-4 leading-tight"
                            data-testid="bon-cadeau-title"
                        >
                            Une attention précieuse
                            <br />
                            pour une{" "}
                            <span className="italic text-rose-700">jeune maman</span>.
                        </h2>

                        <div
                            className="mt-8 space-y-5 text-ink-soft leading-relaxed"
                            data-testid="bon-cadeau-content"
                        >
                            <p>
                                Après une naissance, les mamans pensent souvent à
                                tout… sauf à elles. Elles prennent rarement
                                l'initiative de s'accorder un rendez-vous pour
                                elles-mêmes, alors qu'elles en ont profondément
                                besoin.
                            </p>
                            <p>
                                Offrir un bon cadeau <em>Cindy Bien-Naître</em>, c'est
                                leur permettre de recevoir écoute, soutien et douceur
                                à un moment clé de leur vie.
                            </p>
                            <p className="flex items-start gap-2">
                                <Heart
                                    size={16}
                                    className="text-rose-700 mt-1 shrink-0"
                                    strokeWidth={1.8}
                                />
                                <span>
                                    Un cadeau utile, rassurant et rempli de
                                    bienveillance, pour prendre soin d'elles autant
                                    que de leur bébé.
                                </span>
                            </p>
                        </div>

                        <div className="mt-10 flex flex-wrap gap-4">
                            <a
                                href="tel:+33661255241"
                                data-testid="bon-cadeau-cta-phone"
                                className="inline-flex items-center gap-2 rounded-full bg-rose-700 text-cream px-7 py-3.5 text-sm tracking-wide hover:bg-rose-800 transition-colors duration-300"
                            >
                                <Phone size={16} />
                                Commander un bon cadeau
                            </a>
                            <a
                                href="mailto:cindy.bien.naitre@gmail.com?subject=Demande%20de%20bon%20cadeau"
                                data-testid="bon-cadeau-cta-email"
                                className="inline-flex items-center gap-2 rounded-full border border-line text-ink px-7 py-3.5 text-sm tracking-wide hover:border-rose-700 hover:text-rose-700 transition-all duration-300"
                            >
                                <Mail size={16} />
                                Par e-mail
                            </a>
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
